import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { PERMISSION_EXPENSE_TYPE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import OperatingCostTypeForm from '../../components/OperationCosts/OperatingCostsTypes/OperatingCostTypeForm';
import { URL_EXPENSE_TYPES } from '../../router/constants';

export const Route = createFileRoute('/_authenticated/expense_types/add')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_EXPENSE_TYPE, ['create'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.add',
        suffix: 'menu.expenseTypesOverview',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AddExpenseTypeRoute,
});

function AddExpenseTypeRoute() {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate({ to: URL_EXPENSE_TYPES });
  }, [navigate]);

  return <OperatingCostTypeForm closeCallback={handleClose} customerId={null} />;
}
